import React from 'react';
import { Row, Col, CustomInput } from 'reactstrap';
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import api from '../../../../api/api.js';
const StockConfig = ({ state, setState }) => {
    return (
        <Row>
            <Col xs={12}>
                <CustomInput
                    type="checkbox"
                    id={`Filtro-Stock_FiltrarDepositos`}
                    label="Restringir que depositos se utiliza para computar stock"
                    checked={state.Stock_FiltrarDepositos}
                    onClick={(evt) => {
                        evt.preventDefault();
                        setTimeout(() => setState({ Stock_FiltrarDepositos: !state.Stock_FiltrarDepositos }), 100);
                    }}
                />
            </Col>
            <Col xs={12}>
                <ParadigmaLabeledInput
                    xs={[3, 9]}
                    label="Depositos"
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            disabled={!state.Stock_FiltrarDepositos}
                            url={api.gestion.stock.depositos}
                            clearable={true}
                            multiselect={true}
                            value={state.Stock_DepositosHabilitados}
                            displayField="Nombre"
                            valueField="Codigo"
                            parameters={{ paginationEnabled: "False", sort: ["Nombre"] }}
                            onChange={(data) => setState({ Stock_DepositosHabilitados: (data ? data.map(d => d.Codigo) : []) })}
                        />
                    }
                />
            </Col>
        </Row>
    )
}

export default StockConfig;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Configuracion/StockConfig.js